import React from 'react'

let Noimage = () => {
    return (
        <h1>No Images Found</h1>
    )
}


export default Noimage